import Cookies from 'js-cookie';
import moment from 'moment';
import MathTool from '@utils/MathTool';

class SinglePaymentLoanCalculator
{
    defineSplCalcSliderAnimationJqueryPlugin() {
        //SPL calc
        $.fn.animateSplCalcSlider = function(opts) {

            $.extend({
                dataSelector: 'plugin_loanCalc'
            }, opts);

            var calc = $(this).data(opts.dataSelector);

            var min = calc.getMinLoanAmount();
            var max = calc.getMaxLoanAmount();
            var starting = calc.getStartingLoanAmount();
            var step = calc.settings.sliderStep;
            var queue = [];

            if(step == 100) {
                step = step * 2;
                // } else if(step == 200 || step == 300) {
            }

            var num = min;
            while (num <= max) {
                queue.push(num);
                num = num + step;
            }

            if (num != max) {
                queue.push(max);
            }

            num = max;
            num = max - step;
            while (num >= starting) {
                queue.push(num);
                num = num - step;
            }

            if (num != starting) {
                queue.push(starting);
            }

            // console.log(queue);

            queue.reverse();

            var executeNext = function (num)  {
                var delay = 10;
                calc.$loanAmount.val(num).trigger('change');
                if(num == max) {
                    delay = 700;
                }
                setTimeout(function () {
                    if (queue.length > 0) {
                        executeNext(queue.pop());
                    }

                }, delay);
            };

            if (queue.length > 0) {
                executeNext(queue.pop());
            }

            return $(this);
        };
    }

    defineSplCalcPlugin() {
        (function($, window, document, undefined) {
            "use strict";

            var pluginName = "loanCalc",
                defaults = {
                    currentDate: null,
                    loanAmount: 0.00,
                    interestRates: [],
                    issueFeeRates: [],
                    loanAmountLimits: [],
                    minAmount: 0.00,
                    maxAmount: 0.00,
                    rolloverRates: {},
                    vatRate: 0.00,
                    messages: {
                        minLoanNumberRequirementGeneral: 'Amount available at {number}. loan',
                        minLoanNumberRequirementLast: 'Amount available at {number}+. loan',
                        minLoanNumberRequirement2nd: 'Amount available at 2nd loan',
                        minLoanNumberRequirement3rd: 'Amount available at 3rd loan',
                        minLoanNumberRequirement4th: 'Amount available at 4th loan or more',
                        loanNotAvailable: 'Your maximum loan amount is exceeded',
                        currentLoanOverdue: 'Your active loan is overdue. Please extend the term or repay it.',
                        insufficientIncreaseTerm: 'Insufficient loan increase term',
                        exceededIncreaseTerm: 'Exceeded loan increase term',
                        insufficientLoanLimit: 'Your loan limit is exceeded',
                        cyclePayment: {}
                    },
                    appUrls: {
                        firstTime: '',
                        repeated: '',
                        authorized: ''
                    },
                    holidays: [],
                    minLoanTerm: 2,
                    dateFormat: 'DD/MM/YYYY',
                    shortDateFormat: 'DD/MM',
                    payCycle: 'weekly',
                    payCycles: {},
                    nextPayDate: null,
                    payDateOfMonth: null,
                    semiMonthlyPayDates: null,
                    isLoanAvailable: true,
                    isLoanIncrease: false,
                    authorized: false,
                    onUpdate: null,
                    currentLoanOverdue: false,
                    insufficientIncreaseTerm: false,
                    exceededIncreaseTerm: false,
                    insufficientLoanLimit: false,
                    isFirstLoan: false,
                    customEndDate: null,
                    debug: false,
                    agTermEndDate: null,
                    persistValues: true,
                    semiMonthlyPayDateChoices: {},
                    forceRepeatedLoan: true,
                    sliderStep: null,
                    discounts: [],
                    discountsForceApply: false
                };

            function LoanCalc(element, options) {

                this.element = element;
                this.settings = $.extend({}, defaults, options);

                if (this.settings.debug) {
                    console.log(this.settings);
                }

                this._defaults = defaults;
                this._name = pluginName;

                this.currentDate = this.toDate(this.settings.currentDate);
                this.agTermEndDate = this.toDate(this.settings.agTermEndDate);

                this.$calc = $(this.element);
                this.$payCycle = this.$calc.find('.pay_cycle');
                this.$principalAmount = this.$calc.find('.principal_amount');
                this.$commAmount = this.$calc.find('.comm_amount');
                this.$issuanceFee = this.$calc.find('.issuance_fee_amount');
                this.$totalAmount = this.$calc.find('.total_amount');
                this.$commVatAmount = this.$calc.find('.comm_vat_amount');
                this.$totalVatAmount = this.$calc.find('.total_vat_amount');

                this.$originalCommAmount = this.$calc.find('.original_comm_amount');
                this.$originalIssuanceCommAmount = this.$calc.find('.original_issuance_comm_amount');

                this.$loanAmount = this.$calc.find('input[name="calc_newuser_amount"]');
                this.$nextPayDate = this.$calc.find('.next_pay_date');
                this.$payDateOfMonth = this.$calc.find('.pay_date_of_month');
                this.$semiMonthlyPayDates = this.$calc.find('.semi_monthly_pay_dates');
                this.$endDateLabel = this.$calc.find('.end_date_label');
                this.$fullEndDateLabel = this.$calc.find('.full_end_date_label');
                this.$fullAgTermEndDateLabel = this.$calc.find('.full_ag_term_end_date_label');

                this.$cyclePaymentLabel = this.$calc.find('.cycle_payment_label');

                this.$nextRolloverDays = this.$calc.find('.next_rollover_days');
                this.$nextRolloverFee = this.$calc.find('.next_rollover_fee');
                this.$nextRolloverFeeExclVat = this.$calc.find('.next_rollover_fee_excl_vat');
                this.$nextRolloverDate = this.$calc.find('.next_rollover_date');

                this.$firstTimeLoanBtn = this.$calc.find('.first_time_loan_btn');
                this.$repeatedLoanBtn = this.$calc.find('.repeated_loan_btn');

                this.$slider = this.$calc.find('.jqueryui_slider');
                this.$sliderHint = this.$calc.find('.slider_hint_msg');
                this.$inpHint = this.$calc.find('.inp_hint_msg');

                this.$appBtn = this.$calc.find('.app_btn');
                this.$repaymentTooltip = this.$calc.find('.repayment_tooltip');

                this.nextPayDate = null;
                this.payDateOfMonth = null;
                this.semiMonthlyPayDates = null;

                this.endDate = null;
                this.adjustedEndDate = null;
                this.rolloverDate = null;
                this.adjustedRolloverDate = null;

                this.loanTerm = null;
                this.payCycle = null;

                this.$nextPayDateSelector = this.$calc.find('.next_pay_date_selector');
                this.$payDateOfMonthSelector = this.$calc.find('.pay_date_of_month_selector');
                this.$semiMonthlyPayDatesSelector = this.$calc.find('.semi_monthly_pay_dates_selector');

                this.nextPayDateInitialized = false;
                this.payDateOfMonthInitialized = false;
                this.semiMonthlyPayDatesInitialized = false;

                this.init();
            }

            LoanCalc.ISO_DATE_FORMAT = 'YYYY-MM-DD';

            $.extend(LoanCalc.prototype, {
                init: function() {
                    var that = this;

                    //prevent enter
                    this.$loanAmount.on('keypress', function(e) {
                        if (e.keyCode === 10 || e.keyCode === 13) {
                            e.preventDefault();
                            $(this).trigger('change');
                        }
                    });

                    this.$repaymentTooltip.on('click', function(e) {
                        e.preventDefault();
                    });

                    if (! this.settings.isLoanAvailable) {
                        this.$appBtn.on('click', function(e) {
                            e.preventDefault();
                        });
                    }

                    this.$loanAmount.on('change', function() {
                        var loanAmount = that.toInt(that.$loanAmount.val());
                        var step = that.settings.sliderStep;
                        if (loanAmount > that.getMaxLoanAmount()) {
                            that.$loanAmount.val(that.getMaxLoanAmount()).trigger('change');
                        } else if (loanAmount < that.getMinLoanAmount()) {
                            that.$loanAmount.val(that.getMinLoanAmount()).trigger('change');
                        } else if (step > 0 && loanAmount % step !== 0
                            && loanAmount !== that.getMinLoanAmount() && loanAmount !== that.getMaxLoanAmount()) {
                            loanAmount = Math.round(loanAmount / step) * step;
                            that.$loanAmount.val(loanAmount).trigger('change');
                        } else {
                            that.update();
                        }
                    });

                    var onPayDateChanged = function(payDate) {
                        if (that.settings.customEndDate !== null) {
                            payDate = that.toDate(that.settings.customEndDate);
                        }
                        var adjustedPayDate = that.adjustPayDate(payDate);

                        if (! that.settings.isLoanIncrease) {
                            var minTerm = that.settings.minLoanTerm;
                            while (that.getLoanTerm(adjustedPayDate) < minTerm) {
                                payDate = that.addPayCycle(payDate, that.payCycle, that.payDateOfMonth, that.semiMonthlyPayDates);
                                adjustedPayDate = that.adjustPayDate(payDate);
                            }
                        }

                        that.endDate = payDate;
                        that.adjustedEndDate = adjustedPayDate;
                        that.rolloverDate = that.addPayCycle(payDate, that.payCycle, that.payDateOfMonth, that.semiMonthlyPayDates);
                        that.adjustedRolloverDate = that.adjustPayDate(that.rolloverDate);
                        that.loanTerm = that.getLoanTerm(adjustedPayDate);
                        if (that.settings.minLoanTerm > that.loanTerm) {
                            that.loanTerm = that.settings.minLoanTerm;
                        }

                        that.update();
                    };

                    that.$nextPayDate.on('change', function () {
                        var payDate = that.toDate($(this).val());
                        that.nextPayDate = payDate;
                        onPayDateChanged(payDate);
                    });

                    that.$payDateOfMonth.on('change', function () {
                        var payDay = that.toInt($(this).val());
                        that.payDateOfMonth = payDay;
                        var currentDay = that.currentDate.date();
                        var payDate = moment(that.currentDate);
                        if (payDay <= currentDay) {
                            payDate.add(1, 'M');
                        }
                        var daysInMonth = payDate.daysInMonth();
                        payDate.date(payDay > daysInMonth ? daysInMonth : payDay)
                        onPayDateChanged(payDate);
                    });

                    that.$semiMonthlyPayDates.on(function () {
                        that.semiMonthlyPayDates = $(this).val();
                        var nextPayDates = getPossibleNextPayDateValues(that.currentDate, that.payCycle, 0, that.semiMonthlyPayDates);
                        var payDate = nextPayDates[nextPayDates.length - 1];
                        onPayDateChanged(payDate);
                    });

                    this.$firstTimeLoanBtn.on('change', function() {
                        that.update();
                    });

                    this.$repeatedLoanBtn.on('change', function() {
                        that.update();
                    });

                    var startingLoanAmount = this.getStartingLoanAmount();
                    this.$slider.data('min', this.getMinLoanAmount());
                    this.$slider.data('max', this.getMaxLoanAmount());
                    this.$slider.data('val', startingLoanAmount);
                    this.$slider.data('step', this.settings.sliderStep);
                    this.$loanAmount.val(startingLoanAmount);

                    this.$firstTimeLoanBtn.data('oncheck-limitsliderval', this.getFirstLoanMaxAmount());
                    this.$loanAmount.data('newusermaxval', this.getFirstLoanMaxAmount());

                    this.$payCycle.on('change', function() {
                        that.payCycle = $(this).val();
                        that.$nextPayDateSelector.addClass('hidden');
                        that.$payDateOfMonthSelector.addClass('hidden');
                        that.$semiMonthlyPayDatesSelector.addClass('hidden');
                        if (that.payCycle == 'monthly') {
                            that.$payDateOfMonthSelector.removeClass('hidden');
                            var defVal = 15;
                            if (! that.payDateOfMonthInitialized && that.settings.payDateOfMonth !== null) {
                                defVal = that.settings.payDateOfMonth;
                            }
                            that.payDateOfMonthInitialized = true;
                            that.$payDateOfMonth.val(defVal).trigger('change');
                        } else if (that.payCycle == 'semi_monthly') {
                            that.$semiMonthlyPayDatesSelector.removeClass('hidden');
                            var defVal = '15_30';
                            if (! that.semiMonthlyPayDatesInitialized && that.settings.semiMonthlyPayDates !== null) {
                                defVal = that.settings.semiMonthlyPayDates;
                            }
                            that.semiMonthlyPayDatesInitialized = true;
                            that.$semiMonthlyPayDates.val(defVal).trigger('change');
                        } else {
                            that.$nextPayDateSelector.removeClass('hidden');
                            that.$nextPayDate.empty();
                            var lastVal = '';
                            var dateValues = getPossibleNextPayDateValues(that.currentDate, that.payCycle, 0, null);
                            for (var i = 0; i < dateValues.length; i++) {
                                var date = dateValues[i];
                                var val = date.format(LoanCalc.ISO_DATE_FORMAT);
                                that.$nextPayDate.append('<option value="' + val + '">' + date.format(that.settings.dateFormat)  + '</option>');
                                lastVal = val;
                            }
                            if (! that.nextPayDateInitialized && that.settings.nextPayDate !== null
                                && that.$nextPayDate.find('option[value="' + that.settings.nextPayDate + '"]').length > 0
                            ) {
                                lastVal = that.settings.nextPayDate;
                            }
                            that.nextPayDateInitialized = true;
                            that.$nextPayDate.val(lastVal).trigger('change');
                        }
                    }).val(this.settings.payCycle).trigger('change');
                },

                update: function () {

                    if (this.loanTerm === null) {
                        return;
                    }

                    if (this.settings.debug) {
                        console.log('lt: ' + this.loanTerm);
                    }

                    var loanAmount = this.toInt(this.$loanAmount.val());
                    this.$principalAmount.html(loanAmount);

                    var interestRate = this.getInterestRate(loanAmount, this.loanTerm, true, this.payCycle);
                    var issuanceFeeRates = this.getIssueCommissionRate(loanAmount, this.loanTerm, true, this.payCycle);
                    var originalInterestRate = this.getInterestRate(loanAmount, this.loanTerm, false, this.payCycle);
                    var interest = this.getInterest(loanAmount, this.loanTerm, this.toDailyRate(this.toDecimal(interestRate)));
                    var issueCommission = this.toInt(this.toDecimal( loanAmount * issuanceFeeRates / 100 ).toFixed(0));
                    var originalInterest = this.getInterest(loanAmount, this.loanTerm, this.toDailyRate(this.toDecimal(originalInterestRate)));
                    var vat = this.getVat(interest, this.toDecimal(this.settings.vatRate));
                    var apr = this.getApr(loanAmount, interest, this.loanTerm);

                    var appliedDiscounts = this.getAppliedDiscounts(loanAmount, {
                        'interest': interest,
                        'issuance_fee': issueCommission
                    });

                    if (this.settings.debug) {
                        console.log('applied discounts:');
                        console.log(appliedDiscounts);
                    }

                    var interestRateDiscount = 0;
                    var issuanceFeeRateDiscount = 0;

                    for (var i = 0; i < appliedDiscounts.length; i++) {
                        var ad = appliedDiscounts[i];
                        if (ad.fee === 'interest') {
                            interest -= ad.discountAmount;
                            interestRateDiscount += this.toDecimal(ad.discountPercent);
                        }
                        if (ad.fee === 'issuance_fee') {
                            issueCommission -= ad.discountAmount;
                            issuanceFeeRateDiscount += this.toDecimal(ad.discountPercent);
                        }
                    }

                    if (interestRateDiscount > 100) {
                        interestRateDiscount = 100;
                    }
                    if (issuanceFeeRateDiscount > 100) {
                        issuanceFeeRateDiscount = 100;
                    }

                    interestRate = this.toDecimal(interestRate - (interestRate * (interestRateDiscount / 100)));

                    var comm = interest + vat + issueCommission;
                    var totalExclVat = loanAmount + interest + issueCommission;

                    var total = totalExclVat + vat;

                    apr = MathTool.toFixed10(apr,2);

                    this.$commAmount.html(interest);
                    this.$originalCommAmount.html(originalInterest);
                    this.$totalAmount.html(totalExclVat);
                    this.$originalIssuanceCommAmount.html(this.formatNewMoney(issueCommission));
                    this.$issuanceFee.html(issueCommission);

                    this.$commVatAmount.html(comm);
                    this.$totalVatAmount.html(total);

                    var minLoanNumber = this.getRequiredLoanNumber(loanAmount);
                    this.$inpHint.html(this.getMinLoanNumberMessage(minLoanNumber));

                    this.$endDateLabel.html(this.adjustedEndDate.format(this.settings.dateFormat));
                    this.$fullEndDateLabel.html(this.adjustedEndDate.format(this.settings.dateFormat));
                    this.$fullAgTermEndDateLabel.html(this.agTermEndDate.format(this.settings.dateFormat));

                    var nextRollover = this.getNextRollover(
                        loanAmount,
                        this.payCycle,
                        this.toDecimal(this.settings.vatRate)
                    );

                    this.$nextRolloverDays.html(nextRollover.days);
                    this.$nextRolloverFee.html(nextRollover.totalAmount);
                    this.$nextRolloverFeeExclVat.html(nextRollover.feeAmount);
                    this.$nextRolloverDate.html(this.adjustedRolloverDate.format(this.settings.dateFormat));

                    this.$cyclePaymentLabel.html(this.settings.messages.cyclePayment[this.payCycle]);

                    this.$appBtn.attr('href',
                        this.settings.authorized ? this.settings.appUrls.authorized :
                            ((this.$firstTimeLoanBtn.is(':checked') ? this.settings.appUrls.firstTime : this.settings.appUrls.repeated))
                    );

                    if (this.settings.persistValues) {
                        Cookies.set('spl_calc', {
                            loanAmount: loanAmount,
                            payCycle: this.payCycle,
                            nextPayDate: (this.nextPayDate === null || this.payCycle == 'monthly' ? '' : this.nextPayDate.format(LoanCalc.ISO_DATE_FORMAT)),
                            payDateOfMonth: (this.payDateOfMonth === null|| this.payCycle != 'monthly' ? '' : this.payDateOfMonth),
                            semiMonthlyPayDates: (this.semiMonthlyPayDates === null|| this.payCycle != 'semi_monthly' ? '' : this.semiMonthlyPayDates),
                            referenceDate: this.endDate.format(LoanCalc.ISO_DATE_FORMAT),
                            endDate: this.adjustedEndDate.format(LoanCalc.ISO_DATE_FORMAT)
                        });
                    }

                    var placeholders = {
                        loanAmount: loanAmount,
                        interest: interest,
                        vat: vat,
                        totalExclVat: totalExclVat,
                        total: total,
                        apr: apr,
                        payCycle: this.settings.payCycles[this.payCycle],
                        repaymentDate: this.adjustedEndDate.format(this.settings.dateFormat),
                        agTermEndDate: this.agTermEndDate.format(this.settings.dateFormat),
                        nextRolloverFee: nextRollover.feeAmount,
                        nextRolloverVat: nextRollover.vatAmount,
                        nextRolloverTotal: nextRollover.totalAmount
                    };
                    this.$repaymentTooltip.attr('href', this.$repaymentTooltip.data('url') + '?values=' +  encodeURI(JSON.stringify(placeholders)));

                    if (originalInterest > interest) {
                        //there is discount
                        this.$originalCommAmount.parent().addClass('_str');
                        this.$commAmount.parent().show();
                    } else {
                        this.$originalCommAmount.parent().removeClass('_str');
                        this.$commAmount.parent().hide();
                    }

                    if (this.settings.onUpdate !== null) {
                        this.settings.onUpdate({
                            loanAmount: loanAmount,
                            payCycle: this.payCycle,
                            payReferenceDate: this.nextPayDate,
                            payDateOfMonth: this.payDateOfMonth,
                            semiMonthlyPayDates: this.semiMonthlyPayDates
                        });
                    }
                },

                getInterest: function(loanAmount, loanDays, interestRate) {
                    return this.toInt(this.toDecimal( loanAmount * (interestRate / 100) * loanDays ).toFixed(0));
                },

                getVat: function(interest, vatRate) {
                    return this.toInt(this.toDecimal( interest * (vatRate / 100) ).toFixed(0));
                },

                toDailyRate: function (monthlyRate) {
                    var annualRate = monthlyRate * 12;
                    return annualRate / 360;
                },

                getApr: function(principal, interest, loanDays) {
                    if (principal <= 0) {
                        return 0;
                    }
                    return ( Math.pow( ((principal + interest) / principal), (1 /  (loanDays / 360)) ) - 1 ) * 100;
                },

                getNextRollover: function (loanAmount, payCycle, vatRate) {
                    var days = this.adjustedRolloverDate.diff(this.adjustedEndDate, 'days');
                    var rate = this.getRateByPayCycle(this.settings.rolloverRates, this.payCycle);
                    var rolloverRate = rate === null ? 0 : this.getRateValue(rate, days, loanAmount);
                    if (this.settings.debug) {
                        console.log('rt: ' + days);
                        console.log('rr: ' + rolloverRate);
                    }
                    var amount = this.getInterest(
                        loanAmount,
                        days,
                        this.toDailyRate(rolloverRate)
                    );

                    var vat = this.getVat(amount, vatRate);
                    var feeAmount = amount;
                    var vatAmount = vat;

                    var totalAmount = feeAmount + vatAmount;

                    return {
                        feeAmount: feeAmount,
                        vatAmount: vatAmount,
                        totalAmount: totalAmount,
                        days: days,
                    };
                },

                getMinLoanAmount: function () {
                    return this.toInt(this.settings.minAmount);
                },

                getMaxLoanAmount: function () {
                    return this.toInt(this.settings.maxAmount);
                },

                getCommAmount: function(loanAmount, rate) {
                    return this.toInt(this.toDecimal(loanAmount * (rate / 100)).toFixed(0));
                },

                getFirstLoanMaxAmount: function () {
                    if (this.settings.authorized) {
                        return this.getMaxLoanAmount();
                    }
                    var limits = this.settings.loanAmountLimits;
                    for (var i = 0; i < limits.length; i++) {
                        var lim = limits[i];
                        if (lim.loanNumber == 1) {
                            return this.toInt(lim.maxAmount);
                        }
                    }
                    return this.toInt(this.settings.maxAmount);
                },

                getStartingLoanAmount: function() {
                    var min = this.getMinLoanAmount();
                    var max = this.getMaxLoanAmount();
                    var loanAmount = this.toInt(this.settings.loanAmount);
                    if (min > loanAmount) {
                        return min;
                    }
                    if (max < loanAmount) {
                        return max;
                    }
                    return loanAmount;
                },

                getRequiredLoanNumber: function (loanAmount) {
                    var limits = this.settings.loanAmountLimits;
                    for (var i = 0; i < limits.length; i++) {
                        var lim = limits[i];
                        if (this.toInt(loanAmount) <= this.toInt(lim.maxAmount)) {
                            return lim.loanNumber;
                        }
                    }
                    return 1;
                },

                getMinLoanNumberMessage: function (number) {
                    var messages = this.settings.messages;
                    if (number == 2) {
                        return messages.minLoanNumberRequirement2nd;
                    }
                    if (number == 3) {
                        return messages.minLoanNumberRequirement3rd;
                    }
                    if (number == 4) {
                        return messages.minLoanNumberRequirement4th;
                    }
                    var last = null;
                    var limits = this.settings.loanAmountLimits;
                    for (var i = 0; i < limits.length; i++) {
                        last = limits[i].loanNumber;
                    }
                    var msg = last == number ? messages.minLoanNumberRequirementLast : messages.minLoanNumberRequirementGeneral;
                    return msg.replace('{number}', number);
                },

                toDecimal: function (number) {
                    return parseFloat(number);
                },
                toInt: function (number) {
                    return parseInt(number, 10);
                },
                toDate: function (string) {
                    return moment(string, LoanCalc.ISO_DATE_FORMAT).hours(0).minutes(0).seconds(0).milliseconds(0);
                },
                formatNewMoney: function (amount) {
                    amount = amount.toFixed(2);
                    return amount.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1,');
                },

                adjustPayDate: function (payDate) {
                    var adjustedPayDate = moment(payDate);
                    var that = this;

                    var needsAdjustment = function(d) {
                        for (var i = 0; i < that.settings.holidays.length; i++) {
                            var h = that.settings.holidays[i];
                            if (h.date == d.format(LoanCalc.ISO_DATE_FORMAT)) {
                                return true;
                            }
                        }
                        if (d.day() == 6 || d.day() == 0) {
                            return true;
                        }
                        return false;
                    };

                    if (! needsAdjustment(adjustedPayDate)) {
                        return adjustedPayDate;
                    }

                    for (var i = 0; i < this.settings.holidays.length; i++) {
                        var h = this.settings.holidays[i];
                        if (h.date == adjustedPayDate.format(LoanCalc.ISO_DATE_FORMAT)) {
                            adjustedPayDate = this.toDate(h.payDate);
                            break;
                        }
                    }
                    if (adjustedPayDate.day() == 6) {
                        //Saturday
                        adjustedPayDate = adjustedPayDate.subtract(1, 'd');
                    }
                    if (adjustedPayDate.day() == 0) {
                        //Sunday
                        adjustedPayDate = adjustedPayDate.subtract(2, 'd');
                    }
                    return this.adjustPayDate(adjustedPayDate);
                },

                addPayCycle: function (date, payCycle, dateOfMonth, semiMonthlyPayDates) {
                    var nextPayDates = getPossibleNextPayDateValues(date, payCycle, dateOfMonth, semiMonthlyPayDates);
                    return  nextPayDates[nextPayDates.length - 1];
                },

                getLoanTerm: function (endDate) {
                    return endDate.diff(this.currentDate, 'days');
                },

                getRateByPayCycle: function (collection, payCycle) {
                    for (var i = 0; i < collection.length; i++) {
                        var rate = collection[i];
                        if (rate.payCycles.length === 0 || $.inArray( payCycle, rate.payCycles ) !== -1) {
                            return rate;
                        }
                    }
                    return null;
                },

                getInterestRate: function (loanAmount, term, respectDiscount, payCycle) {
                    var rate = this.getRateByPayCycle(this.settings.interestRates, payCycle);
                    if (rate === null) {
                        return 0;
                    }
                    var rateVal = this.getRateValue(rate, term, loanAmount);
                    if (this.settings.debug) {
                        console.log('ir: ' + rateVal);
                    }
                    // if (! this.settings.firstLoanZeroInterestEnabled) {
                    //     return rateVal;
                    // }
                    if (this.settings.authorized) {
                        return this.settings.isFirstLoan && respectDiscount ? 0 : rateVal;
                    } else {
                        return this.toInt(loanAmount) <= this.toInt(this.getFirstLoanMaxAmount())
                        && this.$firstTimeLoanBtn.is(':checked')
                        && ! this.settings.forceRepeatedLoan
                        && respectDiscount
                            ? 0 : rateVal;
                    }
                },

                getIssueCommissionRate: function (loanAmount, term, respectDiscount, payCycle) {
                    var rate = this.getRateByPayCycle(this.settings.issuanceFeeRates, payCycle);
                    if (rate === null) {
                        return 0;
                    }
                    var rateVal = this.getRateValue(rate, term, loanAmount);
                    if (this.settings.debug) {
                        console.log('ir: ' + rateVal);
                    }
                    return rateVal;
                    /*  if (! this.settings.firstLoanZeroInterestEnabled) {
                          return rateVal;
                      }*/
                    /*  if (this.settings.authorized) {
                          return this.settings.isFirstLoan && respectDiscount ? 0 : rateVal;
                      } else {
                          return this.toInt(loanAmount) <= this.toInt(this.getFirstLoanMaxAmount())
                          && this.$firstTimeLoanBtn.is(':checked')
                          && ! this.settings.forceRepeatedLoan
                          && respectDiscount
                              ? 0 : rateVal;
                      }*/
                },

                getAppliedDiscounts: function (loanAmount, fees) {

                    var isFirstLoan = (this.settings.authorized && this.settings.isFirstLoan) ||
                        (!this.settings.authorized && this.toInt(loanAmount) <= this.toInt(this.getFirstLoanMaxAmount()) && this.$firstTimeLoanBtn.is(':checked'))
                    ;

                    var appliedDiscounts = [];
                    for (var fee in fees) {
                        if (!fees.hasOwnProperty(fee)) {
                            continue;
                        }
                        var feeDiscounts = this.applyDiscountOnFee(fee, fees[fee], isFirstLoan);
                        for (var i = 0; i < feeDiscounts.length; i++) {
                            appliedDiscounts.push(feeDiscounts[i]);
                        }
                    }
                    return appliedDiscounts;
                },

                applyDiscountOnFee: function (fee, feeAmount, isFirstLoan) {
                    var appliedDiscounts = [];

                    var remainingAmount = feeAmount;

                    for (var i = 0; i < this.settings.discounts.length; i++) {
                        var discount = this.settings.discounts[i];
                        var discountPercent = discount.discount;

                        if (remainingAmount <= 0) {
                            break;
                        }

                        if (!isFirstLoan && discount.conditions.firstMainLoan === true && !this.settings.discountsForceApply) {
                            continue;
                        }

                        if (isFirstLoan && discount.conditions.firstMainLoan === false && !this.settings.discountsForceApply) {
                            continue;
                        }

                        if ($.inArray( fee, discount.applicableFees ) === -1) {
                            continue;
                        }

                        var discountAmount = this.getCommAmount(feeAmount, discountPercent);
                        if (discountAmount <= 0) {
                            continue;
                        }

                        if (discountAmount > remainingAmount) {
                            discountAmount = remainingAmount;
                        }

                        appliedDiscounts.push({
                            fee: fee,
                            discountAmount: discountAmount,
                            discountPercent: discountPercent,
                            discount: discount

                        });

                        remainingAmount = remainingAmount - discountAmount;
                    }

                    return appliedDiscounts;
                },

                getRateValue: function (r, term, amount) {
                    if (r === undefined) {
                        return 0;
                    }
                    if (term <= 0) {
                        return 0;
                    }

                    if (! ('source' in r)) {
                        return 0;
                    }

                    if ('simple' === r.source) {
                        return this.toDecimal(r.simpleRate);
                    }
                    if ('file' === r.source) {
                        var table = r.rates === null ? {} : r.rates;
                        var allTerms = table.terms;
                        var termOrMaxTerm = term;
                        if (Array.isArray(allTerms) && allTerms.length > 0) {
                            var maxTerm = Math.max.apply(null, allTerms);
                            termOrMaxTerm = termOrMaxTerm > maxTerm ? maxTerm : termOrMaxTerm;
                        }
                        table = table.rates === null ? {} : table.rates;
                        table =  termOrMaxTerm in table ? table[termOrMaxTerm] : {};
                        var prevRate = null;
                        var firstRate = null;
                        for (var amt in table) {
                            if (! table.hasOwnProperty(amt)) {
                                continue;
                            }
                            var rate = table[amt];
                            if (firstRate === null) {
                                firstRate = amt;
                            }
                            if (amt > amount) {
                                break;
                            }
                            prevRate = rate;
                        }
                        return this.toDecimal(prevRate === null ? firstRate : prevRate);
                    }
                    return 0;
                },

            });

            $.fn[pluginName] = function(options) {
                this.each(function() {
                    if (!$.data(this, "plugin_" + pluginName)) {
                        $.data(this, "plugin_" + pluginName, new LoanCalc(this, options));
                    }
                });
                return this;
            };

        })(jQuery, window, document);
    }

    init() {
        ENV === 'development' && console.log('Calculator::init()');

        this.defineSplCalcSliderAnimationJqueryPlugin();
        this.defineSplCalcPlugin();
    }
}

export default new SinglePaymentLoanCalculator;
